export default (() => {
    const tables = Array.from(document.querySelectorAll('.wysiwyg table'));

    tables.forEach((table) => {
        const tableWrap = document.createElement('div');
        tableWrap.classList.add('table-wrap');
        table.parentNode.insertBefore(tableWrap, table);
        tableWrap.appendChild(table);
    });
})();
